module.exports = __webpack_public_path__ + "99a695faabbc6a27ed05dcf5d3146eb2.svg";